<template>
  <div class="iq-top-navbar">
    <div class="iq-navbar-custom">
      <nav class="navbar navbar-expand-lg navbar-light p-0 d-flex justify-content-between align-items-center border-bottom">
        <div
          class="w-100"
        >
          <div class="d-flex h-100 px-2 py-1">
            <div class="w-100 d-flex gap-2 justify-content-end align-items-center">
              <div
                class="wrapper-menu align-self-center justify-content-center p-2 bg-hover-primary-light rounded"
                @click.prevent="toggleSidebar"
              >
                <div class="main-circle">
                  <i
                    class="fad fa-indent d-block d-md-none"
                    style="font-size: 20px;"
                  />
                  <i
                    class="fad fa-outdent d-none d-md-block"
                    style="font-size: 20px;"
                  />
                </div>
                <div class="hover-circle">
                  <i
                    class="fad fa-outdent d-block d-md-none"
                    style="font-size: 20px;"
                  />
                  <i
                    class="fad fa-indent d-none d-md-block"
                    style="font-size: 20px;"
                  />
                </div>
              </div>
              <div>
                <b class="text-primary d-block d-md-none">{{ user?.location_code }}</b>
                <b class="text-primary d-none d-md-block">{{ user?.location_name }}</b>
              </div>
              <div class="flex-grow-1 d-flex gap-2 justify-content-end align-items-center">
                <div class="d-flex gap-x-3">
                  <div class="notification-toggler bg-hover-primary-light rounded">
                    <i
                      id="popover-notification"
                      class="fad fa-bell p-2"
                      style="font-size: 20px;"
                    />
                    <BPopover
                      target="popover-notification"
                      placement="bottom"
                      custom-class="mt-3"
                      boundary-padding="20px"
                    >
                      <template #title>
                        Notications
                      </template>
                      <div class="w-225px">
                        Notification Lists Here When Implemented
                      </div>
                    </BPopover>
                  </div>
                </div>
                <div class="close-open-icon">
                  <span
                    id="popover-profile"
                    class="cursor-pointer d-flex justify-content-center align-items-center bg-hover-primary-light text-hover-primary rounded p-1 px-2"
                  >
                    <BAvatar
                      :text="getUserAbrevation"
                      variant="primary"
                      class="font-weight-bolder"
                      size="35px"
                    />
                    <div class="px-2 d-none d-md-block">
                      <div>{{ user ? user.name : null }}</div>
                      <small class="text-muted">{{ user ? user.role_name : null }}</small>
                    </div>
                    <div class="ml-1 d-flex align-items-center justify-content-center w-15px">
                      <i class="fad fa-chevron-right closed" />
                      <i class="fad fa-chevron-down opened" />
                    </div>
                  </span>
                  <BPopover
                    target="popover-profile"
                    placement="bottom"
                    custom-class="mt-3"
                    boundary-padding="20px"
                  >
                    <template #title>
                      <div class="text-center">
                        <h5 class="text-white">
                          {{ user ? user.name : null }}
                        </h5>
                        <h6 class="small text-white">
                          {{ user ? user.role_name : null }}
                        </h6>
                      </div>
                    </template>
                    <div class="w-225px">
                      <BOverlay
                        rounded
                        opacity="1"
                        spinner-variant="primary"
                        :bg-color="darkMode ? '#2e2e30' : '#fff'"
                        :show="state.busy"
                      >
                        <BLink
                          href="#"
                          class="d-flex align-items-center py-2 bg-hover-primary-light text-hover-primary rounded"
                          @click.prevent="darkChange(!darkMode)"
                        >
                          <div class="px-2">
                            <i
                              v-if="darkMode"
                              class="fa-xl fad fa-brightness mb-0"
                            />
                            <i
                              v-else
                              class="fa-xl fad fa-moon mb-0"
                            />
                          </div>
                          <div class="flex-grow-1">
                            {{ darkMode ? 'Light' : 'Dark' }} Mode
                          </div>
                        </BLink>
                        <RouterLink
                          :to="{name: 'shared.account.settings'}"
                        >
                          <div class="d-flex align-items-center py-2 bg-hover-primary-light text-hover-primary rounded">
                            <div class="px-2">
                              <i class="fa-xl fad fa-cog mb-0" />
                            </div>
                            <div class="flex-grow-1">
                              Account Settings
                            </div>
                          </div>
                        </RouterLink>
                        <BDropdownDivider style="list-style: none;" />
                        <BLink
                          href="#"
                          class="d-flex align-items-center py-2 bg-hover-danger-light rounded"
                          @click.prevent="clearUserSession"
                        >
                          <div class="px-2">
                            <i class="fa-xl fad fa-sign-out text-danger mb-0" />
                          </div>
                          <div class="flex-grow-1 text-danger">
                            Log Out
                          </div>
                        </BLink>
                      </BOverlay>
                    </div>
                  </BPopover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { core, APPNAME } from '@/config/pluginInit'

import { SSharedAuth } from '@/services/shared'

export default {
  name: 'Header',

  data () {
    return {
      state: {
        busy: false
      },
      appName: APPNAME
    }
  },

  computed: {
    ...mapGetters({
      darkMode: 'settings/darkModeState',
      user: 'auth/user',
      loggingOut: 'auth/loggingOut'
    }),
    getUserAbrevation () {
      if (this.user?.name) {
        return String(this.user.name).charAt(0)
      }
      return ''
    }
  },

  methods: {
    toggleSidebar () {
      core.triggerSet()
    },

    async clearUserSession () {
      if (!this.state.busy && !this.loggingOut) {
        this.state.busy = true
        this.isLoggingOut(true)

        await SSharedAuth.logout().then(
          () => {
            this.$store.dispatch('auth/logout').finally(() => {
              this.$router.replace({ name: 'shared.login' })
            })
          }
        ).finally(() => {
          this.isLoggingOut(false)
          this.state.busy = false
        })
      }
    },

    darkChange (mode) {
      this.modeChange({ rtl: false, dark: mode })
    },

    ...mapActions({
      modeChange: 'settings/layoutModeAction',
      isLoggingOut: 'auth/isUserLoggingOut'
    })
  }
}
</script>
